module.exports = __webpack_public_path__ + "static/07-d6b777df1a70b669aa49f416da4cb3d3.jpg";